import { Panel } from "../Panel/Panel.jsx";
import "./InfoTable.css";

export function InfoTable({ rows, labelWidth = "8rem", stretch = false, frameless = false, scroll = false }) {
  const className = [
    "info-table",
    stretch ? "info-table--stretch" : "",
    frameless ? "info-table--frameless" : ""
  ]
    .filter(Boolean)
    .join(" ");
  const TableWrapper = frameless ? "section" : Panel;

  return (
    <TableWrapper className={className} style={{ "--info-table-label-width": labelWidth }} scroll={scroll}>
      <table class="info-table-grid">
        <tbody>
          {rows.map((row, index) => (
            <tr key={`${row.label}-${index}`}>
              <th scope="row">{row.label}</th>
              <td>{row.value}</td>
              <td class={`info-table-status ${row.status?.tone ? `tone-${row.status.tone}` : ""}`}>
                <span class="info-table-status-content">{row.status?.content ?? ""}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </TableWrapper>
  );
}
